// Shared reader for the report font / style settings configured in Template Settings.
// Login.jsx and TemplateSetting.jsx persist a single object in localStorage under
// the key 'FontStyle'. Older builds stored a one-item array, so both shapes are
// normalised here and every template reads through this helper.
export const readFontStyle = () => {
  try {
    const raw = JSON.parse(localStorage.getItem('FontStyle'));
    if (!raw) return {};
    const obj = Array.isArray(raw) ? raw[0] || {} : raw;
    return {
      fontfamily: obj.fontfamily || '',
      fontsize: obj.fontsize || '',
      fontweight: obj.fontweight || '',
      electronicSignatureMsg: obj.electronicSignatureMsg || '',
    };
  } catch (e) {
    console.error('Failed to parse FontStyle from localStorage', e);
    return {};
  }
};

export const DEFAULT_ELEC_SIGNATURE_MSG =
  'This is a computer-generated report and does not require a physical signature.';

// Shared reader for the health commission registration configured in Template
// Settings. Login.jsx and TemplateSetting.jsx cache it under 'HealthCommission'
// as { registrationNo, logo (base64), logoContentType }.
export const readHealthCommission = () => {
  try {
    const raw = JSON.parse(localStorage.getItem('HealthCommission'));
    if (!raw || (!raw.registrationNo && !raw.logo)) return null;
    return raw;
  } catch (e) {
    return null;
  }
};

// Reports show at most this many doctors; Template Settings won't add more.
export const MAX_DOCTORS = 4;

// Shared reader for the doctor records configured in Template Settings.
// Login.jsx and TemplateSetting.jsx persist the list as JSON under 'DoctorInfo'.
export const readDoctors = () => {
  try {
    const raw = JSON.parse(localStorage.getItem('DoctorInfo'));
    return Array.isArray(raw) ? raw.filter((d) => d && d.drname) : [];
  } catch (e) {
    return [];
  }
};
